export const OM_REVIEWER_LOCAL_STORAGE_TOKEN_KEY = 'om-reviewer-user';
